import React, { useRef, useState } from "react";
import { StyleSheet, FlatList, Dimensions } from "react-native";
import MultipleOptionScreen from "../components/MultipleOptionScreen";
// import { FlatList } from "react-native-web";

import Screen from "../components/Screen";
import SingleOptionScreen from "../components/SingleOptionScreen";

function EnterDetailsScreen({ route, navigation }) {
  const [enteredData, setEnteredData] = useState({
    submission_timestamp: JSON.stringify(new Date()),
    type: route.params.type,
    options: {},
    submission_recommendation: {},
  });
  const [currentPage, setCurrentPage] = useState(0);
  const flatList = useRef();
  const screenData = route.params.questions.apptype_questions; //dataValues[route.params.type]
  const [item, setItem] = useState(screenData[0]);
  // console.log(screenData, "sdkls");

  const getItemLayout = (s, index) => ({
    length: 0.3 * Dimensions.get("window").width,
    offset: 0.3 * Dimensions.get("window").width * index,
    index,
  });

  const onNextStep = (data) => {
    setEnteredData(data);
    const nextPage = currentPage + 1;
    if (currentPage === screenData.length - 1) {
      navigation.navigate("Final", { data, lastTwo: false });
    } else {
      // flatList.current.scrollToIndex({ index: nextPage, animated: true });
      // flatList.current.scrollToItem({
      //   animated: true,
      //   item: 0.3 * Dimensions.get("window").width * nextPage,
      //   viewPosition: 0,
      // });
      // flatList.current.scrollToOffset({
      //   animated: true,
      //   offset: 0.3 * Dimensions.get("window").width * nextPage,
      // });
      setCurrentPage(nextPage);
      setItem(screenData[nextPage]);
    }
  };

  const onPrevious = () => {
    const prevPage = currentPage - 1;
    // flatList.current.scrollToIndex({ index: prevPage, animated: true });
    setCurrentPage(prevPage);
    setItem(screenData[prevPage]);
  };

  const onScrollEnded = () => {};

  return (
    <Screen style={styles.container}>
      <ul
        style={{
          display: "flex",
          flex: 1,
          marginTop: 0,
          marginLeft: -40,
        }}
      >
        {/* {screenData.map((items) => { */}
        {item.question_type === "multiple" && (
          <MultipleOptionScreen
            style={styles.container}
            field={item.question_statement}
            max={parseInt(item.question_max_selection || 3)}
            first={currentPage === 0 ? true : false}
            last={currentPage === screenData.length - 1 ? true : false}
            data={item.question_options}
            item={item}
            enteredData={enteredData}
            onNextPress={onNextStep}
            onPrevious={onPrevious}
          />
        )}
        {item.question_type !== "multiple" && (
          <SingleOptionScreen
            style={styles.container}
            field={item.question_statement}
            first={currentPage === 0 ? true : false}
            last={currentPage === screenData.length - 1 ? true : false}
            data={item.question_options}
            item={item}
            enteredData={enteredData}
            onNextPress={onNextStep}
            onPrevious={onPrevious}
          />
        )}
        {/* })} */}
      </ul>
      {/* <FlatList
        style={styles.container}
        ref={flatList}
        // initialScrollIndex={currentPage}
        horizontal
        pagingEnabled
        scrollEnabled={false}
        // initialNumToRender={60}
        onScrollAnimationEnd={onScrollEnded}
        showsHorizontalScrollIndicator={false}
        data={screenData}
        keyExtractor={(field) => field.record_id}
        // getItemLayout={getItemLayout}
        // onScrollToIndexFailed={(info) => {
        // console.log(info, info.index, "jksd");
        // const wait = new Promise((resolve) => setTimeout(resolve, 500));
        // wait.then(() => {
        //   flatList.current?.scrollToIndex({
        //     index: info.index,
        //     animated: false,
        //   });
        // });
        // }}
        renderItem={({ item }) => {
          // console.log(screenData, "fks", item);
          if (item.question_type === "multiple") {
            return (
              <MultipleOptionScreen
                style={styles.container}
                field={item.question_statement}
                max={parseInt(item.question_max_selection || 3)}
                first={currentPage === 0 ? true : false}
                last={currentPage === screenData.length - 1 ? true : false}
                data={item.question_options}
                item={item}
                enteredData={enteredData}
                onNextPress={onNextStep}
                onPrevious={onPrevious}
              />
            );
          } else {
            return (
              <SingleOptionScreen
                style={styles.container}
                field={item.question_statement}
                first={currentPage === 0 ? true : false}
                last={currentPage === screenData.length - 1 ? true : false}
                data={item.question_options}
                item={item}
                enteredData={enteredData}
                onNextPress={onNextStep}
                onPrevious={onPrevious}
              />
            );
          }
        }}
        // ItemSeparatorComponent={() => <ListItemSeparator />}
      /> */}
    </Screen>
  );
}

const styles = StyleSheet.create({
  container: {
    // width: 1.0 * Dimensions.get("window").width,
    // height: 1.0 * Dimensions.get("window").height,
    flex: 1,
    // alignItems: "center",
  },
});

export default EnterDetailsScreen;
